import { type CsticId } from "~/Configurators/Linear/models";
import { useCsticInputProps } from "~/Configurators/Shaft/components/useCsticInputProps";
import { type SubstepType } from "~/Configurators/Linear/dtos";
import CustomNumberFormat from "~/common/components/CustomNumberFormat";
import LanguageAwareExternalContent from "~/Configurators/Linear/components/LanguageAwareExternalContent";
import type { ReactNode } from "react";

interface Props {
  className?: string;
  csticId: CsticId;
  substepType: SubstepType;
  label?: string;
  helperLabel?: ReactNode;
  decimalScale?: number;
  disabled?: boolean;
  csticsToNull?: string[];
  csticsToSet?: Array<CsticToSet | Resolver>;
  required?: boolean;
  error?: boolean;
  useCsticLabel?: boolean;
}

type CsticToSet =
  | {
      key: string;
      value: string | null;
    }
  | undefined;

type Resolver = (value: string | null) => CsticToSet;

export const SimpleCsticNumberField = ({
  className,
  csticId,
  substepType,
  label,
  csticsToNull,
  csticsToSet,
  helperLabel,
  decimalScale = 1,
  disabled,
  required,
  error,
  useCsticLabel,
}: Props) => {
  const { handleState, ...rest } = useCsticInputProps({
    csticId,
    substep: substepType,
    csticsToNull,
    csticsToSet,
    type: "number",
    required,
    error,
    useCsticLabel,
  });

  return (
    <CustomNumberFormat
      className={className}
      label={
        label ? (
          <LanguageAwareExternalContent content={label} loadedClassname={"scha__lc__external-label"} />
        ) : undefined
      }
      helperText={helperLabel}
      decimalScale={decimalScale}
      disabled={disabled}
      {...rest}
      handleState={(e) => {
        const a = rest.value?.toFixed(decimalScale);
        const b = e.floatValue?.toFixed(decimalScale);
        if (a !== b) {
          handleState(e);
        }
      }}
      slotProps={{
        formHelperText: {
          className: "f-pre-line",
        },
      }}
    />
  );
};
